<div class="container-tab-lists new-table-style">
  <h2>
    @if (defaults.getManagementNameParts(); as parts) {
      Operational planning / Budget {{isBranchReporting() ? 'Branch Reporting ' : ''}} ({{parts.prefix}}@for (gf of parts.gfParts; track gf; let i = $index) {
      @if (i > 0) {
        <span> / </span>
        }<span [class.gf-selected]="gf === parts.selectedGF">{{gf}}</span>
        } - {{defaults.fiscalYear - 1}}/{{defaults.fiscalYear}})
      } @else {
        {{title}}
      }
      {{isAllLoaded === false && !hideSections() ? waitHeader : ''}}
    </h2>

    <mat-tab-group mat-stretch-tabs="false" [(selectedIndex)]="selectedTabIndex" #tabGroup (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel)">
      @if ((defaults.isYearlyOPLEnabled && router.url.includes('oplkpimanagement'))
        || (defaults.isYearlyOPLBranchReportingEnabled && router.url.includes('oplkpibranchreporting'))) {
        <mat-tab label="Yearly planning">
          @if (selectedTabIndex === 0) {
            <div class="oplkpi-inner-tcontainer-tab">
              <p>&nbsp;</p>
              <div style="display:flow-root">
                @if (!hideSections()) {
                  <div style="float:left; width:40vw">
                    <app-filter
                      [separatorKeysCodes]="separatorKeysCodes"
                      [addOnBlur]="addOnBlur"
                      [disabled]="isAllLoaded === false"
                      [searchItems]="searchItems"
                      [selectable]="selectable"
                      [removable]="removable"
                      [isShowAllEnabled]="isShowAllEnabled"
                      (filterChange)="filter = $event"
                    ></app-filter>
                  </div>
                }
                <div style="text-align:right; float:right">
                  @if (isEditModeEnabled) {
                    <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
                      <span class='glyphicon glyphicon-floppy-disk'></span> Save
                    </a>
                  }
                  @if (!isEditModeEnabled) {
                    <a style="display:none" class='kpi-edit-menu' title="Save">
                      {{isApprovalModeEnabled === false ? 'Approval Mode' : 'Cancel'}}
                    </a>
                  }
                  @if (defaults.userCanReleaseMersy() && hideSections()) {
                    <a class='kpi-button-menu' title="Release Mode" (click)="onClickReleaseMode(true)">
                      {{'Release All'}}
                    </a>
                  }
                  @if (!isEditModeEnabled && defaults.userCanReleaseMersy() && !hideSections()) {
                    <a class='kpi-button-menu' title="Release Mode" (click)="toggleRelease();isRevokeActive ? toggleRevoke():null">
                      {{releaseButtonText}}
                    </a>
                  }
                  @if (defaults.userCanRevokeMersy() && hideSections()) {
                    <a class='kpi-button-menu' title="Revoke all released values" (click)="onClickRevoke(true);isReleaseActive ? toggleRelease():null ">
                      {{'Revoke All'}}
                    </a>
                  }
                  <!--<a class='kpi-button-menu' title="Revoke all released values" (click)="toggleRevoke();isReleaseActive ? toggleRelease():null " *ngIf=" !isEditModeEnabled && (showPrereleaseLabel || showReleaseLabel) && defaults.isMersyAdminUser && !hideSections()">
                  {{revokeButtonText}}
                </a>-->
                @if ( !isEditModeEnabled && (showPrereleaseLabel) && defaults.userCanRevokeMersy() && !hideSections()) {
                  <a class='kpi-button-menu' title="Revoke all released values" (click)="toggleRevoke();isReleaseActive ? toggleRelease():null ">
                    {{revokeButtonText}}
                  </a>
                }
                @if (!isExcelModeEnabled && !isEditModeEnabled && !isReleaseActive && defaults.userCanEditMersy()) {
                  <a class='kpi-button-menu' title="Excel" (click)="onClickExcelButton()">
                    Excel
                  </a>
                }
                @if (isExcelModeEnabled) {
                  <a class='kpi-button-menu' title="Download" (click)="downloadYearlyExcelInformation()">
                    <span class='glyphicon glyphicon-download'></span> Download
                  </a>
                }
                @if (isExcelModeEnabled && defaults.userCanEditMersy()) {
                  <a class='kpi-button-menu' title="Upload" (click)="goUploadYearlyFileView()">
                    <span class='glyphicon glyphicon-upload'></span> Upload
                  </a>
                }
                @if (isExcelModeEnabled) {
                  <a class='kpi-button-menu' title="Cancel" (click)="onClickCancelButton()">
                    {{'Exit Excel mode'}}
                  </a>
                }
                @if (!isReleaseActive && !isExcelModeEnabled && !hideSections() && defaults.userCanEditMersy()) {
                  <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
                    <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
                  </a>
                }
                @if (isShowAllEnabled === false && !hideSections()) {
                  <a class='kpi-button-menu' title="Show All" (click)="onClickShowAllButton()">
                    <span class='glyphicon glyphicon-eye-open'></span> Show All
                  </a>
                }
                @if (isShowAllEnabled === true&& !hideSections()) {
                  <a class='kpi-button-menu' title="Hide empty" (click)="onClickShowAllButton()">
                    <span class='glyphicon glyphicon-eye-close'></span> Hide empty
                  </a>
                }
                @if (!hideSections()) {
                  <h5>
                    @if (!isBranchReporting()) {
                      <span style="color: #e57373; font-weight: bold;">BUD, P1 and P2 must all be filled to save</span>
                    }
                    @if (!isBranchReporting()) {
                      <span> / </span>
                    }
                    @if (isShowAllEnabled === true) {
                      <span>Showing all available entries </span>
                    }
                    @if (isShowAllEnabled === false) {
                      <span>Excluding empty values </span>
                    }
                    @if ((showReleaseLabel === true || showPrereleaseLabel === true) || isEditModeEnabled === true) {
                      <span> / </span>
                    }
                    @if (isEditModeEnabled === true) {
                      <span class="salmon-color"> Editable kpi values</span>
                    }
                    @if ((showReleaseLabel === true || showPrereleaseLabel === true) && isEditModeEnabled === true) {
                      <span> / </span>
                    }
                    @if ((showReleaseLabel === true || showPrereleaseLabel === true)) {
                      <span class="green-release-color">Released kpi values </span>
                    }
                  </h5>
                }
                @if (!hideSections()) {
                  <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
                    Edit Mode is enabled. Please click on Save button to save all changes
                  </h5>
                }
              </div>
            </div>
            <br />
            @if (!hideSections()) {
              <oplkpimanagement-list [list]="list"
                [isEditModeEnabled]="isEditModeEnabled"
                [filter]="filter"
                [isApprovalModeEnabled]="isApprovalModeEnabled"
                [auxFilterPredicate]="auxFilterPredicate"
                [isShowAllEnabled]="isShowAllEnabled"
                [isReleaseActive]="isReleaseActive && !isEditModeEnabled"
                [isRevokeActive]="isRevokeActive && !isEditModeEnabled"
                (onClickRevokeMode)="onClickRevoke($event)"
                (onClickReleaseMode)="onClickReleaseMode($event)"
              ></oplkpimanagement-list>
            }
          </div>
        }
      </mat-tab>
    }
    @if ((defaults.isMonthlyOPLEnabled && router.url.includes('oplkpimanagement'))
      || (defaults.isMonthlyOPLBranchReportingEnabled && router.url.includes('oplkpibranchreporting'))) {
      <mat-tab label="Monthly planning">
        @if (selectedTabIndex === 1) {
          <div class="oplkpi-inner-tcontainer-tab">
            <p>&nbsp;</p>
            <div style="display:flow-root">
              @if (!hideSections()) {
                <div style="float:left; width:40vw">
                  <app-filter
                    [separatorKeysCodes]="separatorKeysCodes"
                    [addOnBlur]="addOnBlur"
                    [disabled]="isAllLoaded === false"
                    [searchItems]="searchItems"
                    [selectable]="selectable"
                    [removable]="removable"
                    [isShowAllEnabled]="isShowAllEnabled"
                    (filterChange)="filter = $event"
                  ></app-filter>
                </div>
              }
              <div style="text-align:right; float:right">
                @if (isEditModeEnabled) {
                  <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
                    <span class='glyphicon glyphicon-floppy-disk'></span> Save
                  </a>
                }
                @if (!isEditModeEnabled && defaults.userCanReleaseMersy() && !hideSections()) {
                  <a class='kpi-button-menu' title="Release Mode" (click)="toggleMonthlyRelease();isMonthlyRevokeActive ? toggleMonthlyRevoke():null">
                    {{releaseMonthlyButtonText}}
                  </a>
                }
                @if (!isEditModeEnabled && showReleaseLabel && defaults.userCanRevokeMersy() && !hideSections()) {
                  <a class='kpi-button-menu' title="Revoke all released values" (click)="toggleMonthlyRevoke();isMonthlyReleaseActive ? toggleMonthlyRelease():null ">
                    {{revokeMonthlyButtonText}}
                  </a>
                }
                @if (defaults.userCanReleaseMersy() && hideSections()) {
                  <a class='kpi-button-menu' title="Release Mode" (click)="onClickReleaseMode(false)">
                    {{'Release All'}}
                  </a>
                }
                @if (defaults.userCanRevokeMersy() && hideSections()) {
                  <a class='kpi-button-menu' title="Revoke all released values" (click)="onClickRevoke(false)">
                    {{'Revoke All'}}
                  </a>
                }
                @if (!isExcelModeEnabled && !isEditModeEnabled && !isReleaseActive && defaults.userCanEditMersy()) {
                  <a class='kpi-button-menu' title="Excel" (click)="onClickExcelButton()">
                    Excel
                  </a>
                }
                @if (isExcelModeEnabled) {
                  <a class='kpi-button-menu' title="Download" (click)="downloadMonthlyExcelInformation()">
                    <span class='glyphicon glyphicon-download'></span> Download
                  </a>
                }
                @if (isExcelModeEnabled && defaults.userCanEditMersy()) {
                  <a class='kpi-button-menu' title="Upload" (click)="goUploadMonthlyFileView()">
                    <span class='glyphicon glyphicon-upload'></span> Upload
                  </a>
                }
                @if (isExcelModeEnabled) {
                  <a class='kpi-button-menu' title="Cancel" (click)="onClickCancelButton()">
                    {{'Exit Excel mode'}}
                  </a>
                }
                @if (!isReleaseActive && !isExcelModeEnabled && !hideSections() && defaults.userCanEditMersy()) {
                  <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
                    <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
                  </a>
                }
                @if (isShowAllEnabled === false && !hideSections()) {
                  <a class='kpi-button-menu' title="Show All" (click)="onClickShowAllButton()">
                    <span class='glyphicon glyphicon-eye-open'></span> Show All
                  </a>
                }
                @if (isShowAllEnabled === true && !hideSections()) {
                  <a class='kpi-button-menu' title="Hide empty" (click)="onClickShowAllButton()">
                    <span class='glyphicon glyphicon-eye-close'></span> Hide empty
                  </a>
                }
                @if (!hideSections()) {
                  <h5>
                    @if (isShowAllEnabled === true) {
                      <span>Showing all available entries </span>
                    }
                    @if (isShowAllEnabled === false) {
                      <span>Excluding empty values </span>
                    }
                    @if (showReleaseLabel === true || isEditModeEnabled === true) {
                      <span> / </span>
                    }
                    @if (isEditModeEnabled === true) {
                      <span class="salmon-color"> Editable kpi values</span>
                    }
                    @if (showReleaseLabel === true && isEditModeEnabled === true) {
                      <span>/</span>
                    }
                    @if (showReleaseLabel === true) {
                      <span class="green-release-color">Released kpi values </span>
                    }
                  </h5>
                }
                @if (!hideSections()) {
                  <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
                    Edit Mode is enabled. Please click on Save button to save all changes
                  </h5>
                }
              </div>
            </div>
            <br />
            @if (!hideSections()) {
              <oplmonthlykpimanagement-list [list]="list"
                [isEditModeEnabled]="isEditModeEnabled"
                [filter]="filter"
                [isApprovalModeEnabled]="isApprovalModeEnabled"
                [auxFilterPredicate]="auxFilterPredicate"
                [isShowAllEnabled]="isShowAllEnabled"
                [isMonthlyReleaseActive]="isMonthlyReleaseActive && !isEditModeEnabled"
                [isMonthlyRevokeActive]="isMonthlyRevokeActive && !isEditModeEnabled"
                (onClickRevokeMode)="onClickRevoke($event)"
                (onClickReleaseMode)="onClickReleaseMode($event)"
                >
              </oplmonthlykpimanagement-list>
            }
          </div>
        }
      </mat-tab>
    }
  </mat-tab-group>
</div>




